export enum Sections {
  CHECK_IN_EXPERIENCE = "CheckInExperience"
}

export enum Workflows {
  CHECK_IN_EXPERIENCE = "Check in experience"
}
